/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import { Box, Grid } from '@mui/material';
import useMessageDispatcher from 'hooks/useMessageDispatcher';
import loading from '../../../assets/images/icons/loading.gif';
import DataNotAvailablePage from 'reusable-components/data-not-found';
import Filters from './Filters';
import StudentList from './SemesterStudentList';
import StudentListForBAMS from './SemesterStudentListForBAMS';

const header = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
        'Content-Type': 'application/json'
    }
};
const initialValue = {
    semesterStudentData: [],
    sessionalStudentData: [],
    internalAssessments: [],
    subject: '',
    paperMode: 'REGULAR',
    examList: [],
    batchList: [],
    schoolList: [],
    departmentList: [],
    programList: [],
    semesterList: 0,
    courseList: [],
    examDetails: null,
    selectedProgram: null,
    selectedSubjectDetail: null,
    examId: '',
    batchId: '',
    schoolId: '',
    departmentId: '',
    programId: '',
    semesterNo: 0,
    courseId: '',
    studentId: ''
};
const validationSchema = yup.object().shape({
    examId: yup.string().required('Exam is required. *'),
    batchId: yup.string().required('Batch is required. *'),
    schoolId: yup.string().required('School is required. *'),
    departmentId: yup.string().required('Department is required. *'),
    programId: yup.string().required('Program is required. *'),
    // semesterNo: yup.number().min(1, 'Semester is required. *').required('Semester is required. *'),
    courseId: yup.string().required('Course is required. *'),
    paperMode: yup.string().required('Paper Mode is required.')
});
const PreviousMarksEntry = () => {
    const [isLoading, setIsLoading] = useState(false);
    const showMessage = useMessageDispatcher();
    const formikRef = useRef();

    const fetchExams = async () => {
        try {
            const response = await axios.get(`/v1/exams/exam-group/list?semester=${true}`, header);

            formikRef?.current?.setFieldValue('examList', response.data.data);
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchBatches = async (examId) => {
        try {
            const response = await axios.get(`/v1/exams/list/session?examGroupId=${examId}`, header);
            formikRef?.current?.setFieldValue('batchList', response?.data?.sessions);
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchSchools = async (examId) => {
        try {
            const response = await axios.get(`/v1/exams/get-schools?examGroupId=${examId}`, header);
            const schoolList = response?.data?.data;
            const uniqueSchools = Object.values(
                schoolList?.reduce((acc, school) => {
                    acc[school?.id] = school;
                    return acc;
                }, {})
            );
            formikRef?.current?.setFieldValue('schoolList', uniqueSchools);
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchtDepartments = async (examId, schoolId) => {
        try {
            const response = await axios.get(`/v1/exams/get-departments?examGroupId=${examId}&schoolId=${schoolId}`, header);
            formikRef?.current?.setFieldValue('departmentList', response?.data?.data);
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchtPrograms = async (sessionId, departmentId) => {
        try {
            const response = await axios.get(
                `/v1/course-details/list/by-college-institute?sessionId=${sessionId}&departmentId=${departmentId}`,
                header
            );
            const allowedIds = formikRef?.current?.values?.examDetails?.courseDetailIds || [];
            const filteredPrograms = response.data.courseDetailList.filter((course) => allowedIds.includes(course.id));
            formikRef?.current?.setFieldValue('programList', filteredPrograms);
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchSubjectDetails = async (batchId, programId, semesterNumber) => {
        try {
            const response = await axios.get(
                `/v1/subjects/subject-detail/by-semester?sessionIds=${batchId}&courseId=${programId}&semester=${semesterNumber}&general=false`,
                header
            );
            formikRef?.current?.setFieldValue('courseList', response?.data?.data);
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const calculateIAMarks = async (courseDetailId, subjectDetailId) => {
        try {
            await axios.get(
                `/v1/internal/assessment/marks/calculate?courseDetailId=${courseDetailId}&subjectDetailId=${subjectDetailId}`,
                header
            );
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchBAMSStudents = async (examId, courseId, subjectId) => {
        try {
            setIsLoading(true);
            const response = await axios.get(
                `/v1/internal/assessment/get/for-previous?examGroupId=${examId}&courseDetailId=${courseId}&subjectDetailId=${subjectId}`,
                header
            );
            if (response.status === 200) {
                setIsLoading(false);
                if (response.data.code !== '403') {
                    formikRef.current.setFieldValue('semesterStudentData', response?.data?.data?.studentMarksList);
                    formikRef.current.setFieldValue('internalAssessments', response?.data?.data?.internalAssessments);
                }
            }
        } catch (error) {
            setIsLoading(false);
            formikRef.current.setFieldValue('semesterStudentData', []);
            formikRef.current.setFieldValue('internalAssessments', []);
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const fetchSessionalStudents = async (examId, courseId, subjectId) => {
        try {
            setIsLoading(true);
            const response = await axios.get(
                `/v1/internal/assessment/get/for-previous?examGroupId=${examId}&courseDetailId=${courseId}&subjectDetailId=${subjectId}`,
                header
            );
            if (response.status === 200) {
                setIsLoading(false);
                formikRef.current.setFieldValue('semesterStudentData', response.data.data.studentMarksList);
                formikRef.current.setFieldValue('internalAssessments', response.data.data.internalAssessments);
            }
        } catch (error) {
            setIsLoading(false);
            formikRef.current.setFieldValue('semesterStudentData', []);
            formikRef.current.setFieldValue('internalAssessments', []);
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const handleSearch = (values) => {
        calculateIAMarks(values?.selectedProgram?.id, values?.selectedSubjectDetail);
        if (values?.selectedProgram?.course?.assessmentStructure === 'BAMS') {
            fetchBAMSStudents(values?.examId, values?.selectedProgram?.id, values?.selectedSubjectDetail);
        } else {
            fetchSessionalStudents(values?.examId, values?.selectedProgram?.id, values?.selectedSubjectDetail);
        }
    };
    useEffect(() => {
        fetchExams();
    }, []);
    return (
        <MainCard>
            <Formik
                initialValues={initialValue}
                onSubmit={handleSearch}
                validationSchema={validationSchema}
                innerRef={formikRef}
                enableReinitialize
            >
                {({ values, setFieldValue, touched, errors, handleChange }) => (
                    <Form>
                        <Filters
                            isLoading={isLoading}
                            values={values}
                            setFieldValue={setFieldValue}
                            touched={touched}
                            errors={errors}
                            handleChange={handleChange}
                            fetchBatches={fetchBatches}
                            fetchSchools={fetchSchools}
                            fetchtDepartments={fetchtDepartments}
                            fetchtPrograms={fetchtPrograms}
                            fetchSubjectDetails={fetchSubjectDetails}
                        />
                        {isLoading ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <img height="180px" src={loading} alt="Loading" />
                            </Box>
                        ) : values?.semesterStudentData?.length > 0 ? (
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {values?.selectedProgram?.course?.assessmentStructure !== 'BAMS' ? (
                                        <StudentList
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            setIsLoading={setIsLoading}
                                            handleSearch={handleSearch}
                                        />
                                    ) : (
                                        <StudentListForBAMS
                                            values={values}
                                            setFieldValue={setFieldValue}
                                            setIsLoading={setIsLoading}
                                            handleSearch={handleSearch}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        ) : (
                            <DataNotAvailablePage style={{ height: '55vh' }} />
                        )}
                    </Form>
                )}
            </Formik>
        </MainCard>
    );
};

export default PreviousMarksEntry;
